import { useTopOfPageContent } from "@faire/retailer-visitor-shared/stores/ui/useTopOfPageContent";
import { ChapterNavCard } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guidePages/components/ChapterNavCard";
import { OtherGuideLinks } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guidePages/components/OtherGuideLinks";
import type { FaireAcademyChapter } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/types";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IFaireAcademyChapter } from "@faire/web-api--source/indigofair/data/IFaireAcademyChapter";
import * as React from "react";
import styled from "styled-components";

export const ChaptersNavSection: React.FC<{
  guideTitle: string;
  chapters: Array<FaireAcademyChapter>;
  readChapters: Set<
    keyof typeof IFaireAcademyChapter.ChapterIdentifier | undefined
  >;
}> = ({ guideTitle, chapters, readChapters }) => {
  const { headerPlusPromoBannerHeight } = useTopOfPageContent();

  return (
    <nav>
      <StickyColumn $top={headerPlusPromoBannerHeight + 40}>
        <OtherGuideLinks />
        <Spacer height="1x" />
        <Typography variant="displaySSerifRegular">
          <StrictLocalMsg
            defaultMessage="Chapters"
            description={{
              text: "Title above list of chapters in a Open with Faire guide",
              img: "https://cdn.faire.com/fastly/0746dc9b30abbd53f8568f60275e5f24244f6793382618f0997926fbf1a79259.png",
            }}
          />
        </Typography>
        <Spacer height="3x" />
        {chapters.map((chapter, index) => {
          return (
            <React.Fragment key={chapter.title}>
              {index !== 0 ? <Spacer height={12} /> : null}
              <ChapterNavCard
                guideTitle={guideTitle}
                chapter={chapter}
                isRead={readChapters.has(chapter.id)}
              />
            </React.Fragment>
          );
        })}
      </StickyColumn>
    </nav>
  );
};

const StickyColumn = styled(Column)<{ $top: number }>`
  ${responsiveMediaQueries.tabletAndAbove} {
    position: sticky;
    z-index: 1;
    top: ${({ $top }) => $top}px;
  }

  ${responsiveMediaQueries.mobile} {
    width: 100%;
  }
`;
